import { render, staticRenderFns } from "./addZz.vue?vue&type=template&id=34a122ef&scoped=true&"
import script from "./addZz.vue?vue&type=script&lang=js&"
export * from "./addZz.vue?vue&type=script&lang=js&"
import style0 from "./addZz.vue?vue&type=style&index=0&id=34a122ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a122ef",
  null
  
)

export default component.exports